import * as Sentry from '@sentry/browser';
import type { Integration } from '@sentry/core';

import type {
  AlertingService,
  AnonymousUser,
  UserInformation,
  UserInformationService,
} from '../application';

export class SentryAlertingService
  implements AlertingService, UserInformationService
{
  constructor({
    sentryConfig,
    sentryIntegrations,
  }: {
    sentryConfig?: Sentry.BrowserOptions;
    sentryIntegrations?: Array<Integration>;
  }) {
    Sentry.init({
      ...sentryConfig,
      integrations: sentryIntegrations || [],
    });
  }

  reportError(error: Error, extras?: any, tags?: Record<string, string>) {
    Sentry.withScope(scope => {
      if (extras) {
        scope.setExtras(extras);
      }
      if (tags) {
        scope.setTags(tags);
      }
      Sentry.captureException(error);
    });
  }

  reportMessage(message: string) {
    Sentry.captureMessage(message);
  }

  setUserInformation(userInformations: UserInformation | AnonymousUser) {
    Sentry.getCurrentScope().setUser(userInformations);
  }

  addBreadcrumb(
    message: string,
    data?: {
      [key: string]: any;
    },
  ) {
    Sentry.addBreadcrumb({ message, data });
  }
}
